import { groupValueByTimestamp } from '../components/displays/shared/utils/apply-value-representation.js';
import {
  TimeseriesBandSlotProps,
  ChartVariantInternal,
  TimeseriesVariantSlotProps,
  ValueRepresentationPerVariant,
} from '../types/timeseries.js';

export function getRelativeConf(
  series: TimeseriesBandSlotProps[] | TimeseriesVariantSlotProps[],
  variant: ChartVariantInternal,
  valueRepPerVariant: ValueRepresentationPerVariant,
  nonStackedMap?: {
    groupedValues: Map<string, number>;
    maxValuesByUnit: Map<string, number>;
    uniqueUnits: Map<string, boolean>;
  },
) {
  const relative = valueRepPerVariant.get(variant) === 'relative';

  if (relative) {
    return groupValueByTimestamp(
      series as TimeseriesVariantSlotProps[],
      nonStackedMap,
    );
  }
}
